import * as Yup from "yup";

/**
 * Optional numeric field: empty string / null / undefined → undefined.
 * When a value is present it must be ≥ 0.
 */
export const optionalNonNegativeNumber = (
  tFn: (key: string, fallback: string) => string,
  msgKey: string,
  fieldLabel: string
) =>
  Yup.number()
    .transform((val, orig) =>
      orig === "" || orig === null || orig === undefined ? undefined : val
    )
    .nullable()
    .optional()
    .min(0, tFn(msgKey, `${fieldLabel} must be 0 or greater`));

/**
 * Required numeric field: empty string / null / undefined → undefined (then
 * caught by `.required()`). When present must be ≥ 0.
 */
export const requiredNonNegativeNumber = (
  tFn: (key: string, fallback: string) => string,
  requiredKey: string,
  requiredFallback: string,
  minKey: string,
  minFallback: string
) =>
  Yup.number()
    .transform((val, orig) =>
      orig === "" || orig === null || orig === undefined ? undefined : val
    )
    .required(tFn(requiredKey, requiredFallback))
    .min(0, tFn(minKey, minFallback));
